import { createSlice } from "@reduxjs/toolkit";
import { 
  getScheduleFlow, 
  createScheduleFlow, 
  updateScheduleFlow, 
  deleteScheduleFlow,
  clearLocalActiveScheduleFlow
} from "./actions";

export const initialState = {
  scheduleFlow: { 
    id: '', 
    appointment_prompt: '',
    booking_prompt: '',
    patient_prompt: '',
    clinicians_prompt: '', 
    offset_prompt: '',
    filter_slots_prompt: '',
    message: '', 
    no_slots_message: '',
    pull: 'ehr',
    schedule_start_at: '',
    schedule_end_at: '',
    schedule_weekdays: [],
    updated_at: '' 
  },
  loading: false
};

const slice = createSlice({
  name: 'scheduleFlows',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getScheduleFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getScheduleFlow.fulfilled, (state, action) => {
        const { schedule_flow } = action.payload;
        const scheduleFlow = { ...state.scheduleFlow, ...schedule_flow };

        state.loading = false;
        state.scheduleFlow = scheduleFlow;
      })
      .addCase(getScheduleFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createScheduleFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(createScheduleFlow.fulfilled, (state, action) => {
        const { schedule_flow } = action.payload;

        state.loading = false;
        state.scheduleFlow = schedule_flow;       
      })
      .addCase(createScheduleFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateScheduleFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateScheduleFlow.fulfilled, (state, action) => {
        const { status, schedule_flow } = action.payload;
        const updatedScheduleFlow = { ...state.scheduleFlow, ...schedule_flow };

        state.loading = false;
        if (status === 204) state.scheduleFlow = updatedScheduleFlow;       
      })
      .addCase(updateScheduleFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteScheduleFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteScheduleFlow.fulfilled, (state, action) => {
        const { status } = action.payload;

        state.loading = false;
        if (status === 204) state.scheduleFlow = initialState.scheduleFlow;       
      })
      .addCase(deleteScheduleFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(clearLocalActiveScheduleFlow, state => {
        state.scheduleFlow = initialState.scheduleFlow;
      })
  }
})

export default slice.reducer;